<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('checkout:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="提交时间">
                 <a-range-picker  @change="onChangectstamp"  style="width: 100%" />
              </a-form-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="费用类型">
                <a-select v-model="queryParam.treatType"  allow-clear placeholder="请选择订单类型" :options="treatType"></a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
        <template class="table-operator" slot="operator" v-if="hasPerm('checkout:add')" >
          <!-- <a-button type="primary" v-if="hasPerm('checkout:add')" icon="plus" @click="$refs.addForm.add()">新增问诊订单管理</a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('checkout:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button> -->
          <x-down
            v-if="hasPerm('checkout:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template>

        <span slot="action"  slot-scope="text, record">
          <a @click="$refs.addForm.add(record)">详情</a>
        </span>


      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { inquiryorderPage, inquiryorderDelete, inquiryorderExport } from '@/api/modular/interhospital/checkout/checkoutManage'
  import addForm from './viewDetial.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          startDate : '',
          endDate : '',
        },
        // 表头
        columns: [
          {
            title: '结账日期',
            align: 'center',
            dataIndex: 'billDate'
          },
          {
            title: '结账人',
            align: 'center',
            dataIndex: 'checkoutUserName'
          },
          // {
          //   title: '结账收据编号',
          //   align: 'center',
          //   dataIndex: 'billReceiptNo',
          // },
          {
            title: '收据张数',
            align: 'center',
            dataIndex: 'receiptTotal'
          },
          {
            title: '退款数',
            align: 'center',
            dataIndex: 'refundNum',
          },
          {
            title: '退款(元)',
            align: 'center',
            dataIndex: 'refund',
          },
          {
            title: '实收金额(元)',
            align: 'center',
            dataIndex: 'actual'
          },
        ],
        treatType : [
          {
            value: '0',
            label: '全部',
          },
          {
            value: '4',
            label: '问诊费',
          },
          {
            value: '1',
            label: '医护费',
          },
          {
            value: '2',
            label: '护理费',
          },
        ],
       
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return inquiryorderPage(Object.assign(parameter, this.queryParam)).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('checkout:edit') || this.hasPerm('checkout:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        inquiryorderExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },  
      onChangectstamp(event,data){
          // console.log(event,data)
          this.queryParam.startDate = data[0];
          this.queryParam.endDate = data[1];
          console.log(this.queryParam)
      }
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
